// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Kapat',
  error: () => 'Hata',
  warn: () => 'Uyarı',
  info: () => 'Bilgi',
  confirmation: () => 'Teyit',
  progressIndeterminate: () => 'Devam Ediyor',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    p['FROM_SECTION'] + ' ve ' + p['TO_SECTION'] + ' arasında.',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. Eşleşen bölüm bulunamadı.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Değer seçmek için Enter tuşuna basın.',
  indexer_touchInstructionText: () =>
    'İşaret moduna girmek için çıft tıklayıp basılı tutun, ardından aşağı veya yukarı sürükleyerek değeri ayarlayın.',
  inputPassword_show: () => 'Parolayı Göster',
  inputPassword_hide: () => 'Parolayı Gizle',
  inputPassword_hidden: () => 'Parola Gizli',
  formControl_clear: () => 'Temizle',
  formControl_loading: () => 'Yükleniyor ',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    p['MAX_LENGTH'] + ' olan maksimum uzunluk aşıldı.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' karakter kaldı.',
  formControl_requiredMessageDetail: () => 'Bir değer girin.',
  select_requiredMessageDetail: () => 'Bir değer seçin.',
  select_noMatchesFound: () => 'Eşleşme bulunmadı.',
  select_oneMatchFound: () => 'Bir eşleşme bulundu',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' eşleşme bulundu',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' veya daha fazla eşleşme bulundu',
  selectMultiple_selectedValues: () => 'Seçili değerler',
  selectMultiple_showSelectedValues: () => 'Sadece seçili değerleri göster.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' değer seçili.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Seçili değeri kaldırmak için Geri veya Sil tuşuna basın.',
  selectMultiple_apply: () => 'Uygula',
  selectMultiple_back: () => 'Geri',
  selector_selected: () => 'Onay kutusu işaretli',
  selector_unselected: () => 'Onay kutusu işaretli değil',
  userAssistance_learnMore: () => 'Daha fazla bilgi edinin',
  userAssistance_required: () => 'Gerekli',
  filePicker_singleFileUploadError: () => 'Bir seferde karşıya bir tek dosya yükleyin',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Karşıya yükleyemeyeceğiniz dosya tipi: ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Karşıya yükleyemeyeceğiniz dosya tipleri: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'bilinmeyen',
  filePicker_dropzonePrimaryText: () => 'Sürükle ve Bırak',
  filePicker_dropzoneSecondaryText: () => 'Bir dosya seçin veya buraya bir dosya bırakın',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Dosya seçin veya buraya bırakın',
  filePicker_addFiles: () => 'Dosya Ekle',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Arttır',
  inputNumber_decrease: () => 'Azalt',
  inputNumber_converterParseError: () => 'Sayı girin.',
  noData_message: () => 'Görüntülenecek öğe yok',
  message_navigationFromMessagesRegion: () =>
    'Mesajlar bölgesine giriliyor. Önceki odaklanılan öğeye gitmek için F6 tuşuna basın.',
  message_navigationToMessagesRegion: () =>
    'Mesajlar bölgesinde yeni mesajlar var. En yeni mesaj bölgesine F6 tuşuna basın.',
  messageToast_allMessagesClosed: () => 'Tüm durum mesajları kapatıldı.',
  expandableList_groupCollapse: () => 'Daraltıldı',
  expandableList_groupExpand: () => 'Genişletildi',
  expandableList_expandCollapseInstructionText: () =>
    'Genişletmek ve daraltmak için ok tuşlarını kullanın',
  list_suggestion: () => 'Öneri',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Adım ' + p['currentStep'] + ' / ' + p['numberOfSteps'],
  train_current: () => 'Geçerli',
  train_visited: () => 'Ziyaret edildi',
  train_not_visited: () => 'Ziyaret edilmedi',
  train_message_type: () => 'Mesaj Tipi',
  viz_drillable: () => 'Detaylandırılabilir',
  dataVisualization_stateSelected: () => 'Seçildi',
  dataVisualization_stateUnselected: () => 'Seçim Kaldırıldı',
  dataVisualization_noData: () => 'Görüntülenecek veri yok'
};
export default bundle;
